import styled from 'threads5/styles/styled';
import { animated } from '@react-spring/web';

import { Icon } from 'src/components-v2/DataDisplay/Icon';

import {
  Card,
  Disclaimer,
  Form,
  Label,
  Slider,
  ToggleInput,
  ToggleLabel,
  ToggleTrack,
} from 'src/components-v3/Calculator/Calculator.styled';

// Re-export shared calculator styled components. The toggle track is aliased
// because here it doubles as the drop target for the draggable knob.
export {
  Card,
  Disclaimer,
  Form,
  Label,
  Slider,
  ToggleInput,
  ToggleLabel,
  ToggleTrack as DraggableWrapper,
};

// ACH-specific: gradient icon for card header
export const GradientIcon = styled(Icon)(() => {
  return {
    svg: {
      path: {
        fill: 'url(#ach-lightning-gradient)',
      },
    },
  };
});

// ACH-specific: SVG gradient definitions
export const GradientDefs = () => {
  return (
    <svg width='0' height='0' style={{ position: 'absolute' }}>
      <defs>
        <linearGradient
          id='ach-lightning-gradient'
          x1='0%'
          y1='0%'
          x2='100%'
          y2='100%'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0%' stopColor='#42F0CD' />
          <stop offset='100%' stopColor='#0DADF2' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CanvasWrapper = styled(animated.div)(() => {
  return {
    width: '50%',
    height: 48,
    overflow: 'hidden',
    borderRadius: 40,
  };
});

export const Canvas = styled(animated.canvas)(() => {
  return {
    width: 278,
    height: 239,
    borderRadius: 40,
    '--gradient-color-3': '#42F0CD',
    '--gradient-color-4': '#56DDF7',
    '--gradient-color-1': '#D8C2FB',
    '--gradient-color-2': '#E9F',
    margin: '-97px 0px 0px 6px',
    filter: 'blur(4px)',
  };
});

export const Draggable = styled(animated.div)(() => {
  return {
    position: 'absolute',
    top: 0,
    left: 3,
    zIndex: 2,
    width: 'calc(50% - 3px)',
    height: 48,
    cursor: 'grab',
    margin: '3px 0 0 0',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.20)',
    borderRadius: '40px',
  };
});
